import { parse, ParseResult } from "papaparse";

export type CSVRow = { [key: string]: string };

export interface CSVFile {
  rows: CSVRow[];
}

/**
 * Strips a leading title row from CSV text if present. A title row is a single
 * line with no delimiters (commas) that people sometimes add as a label above
 * the real header row.
 */
function stripTitleRow(text: string): string {
  const firstNewline = text.indexOf("\n");
  if (firstNewline === -1) return text;

  const firstLine = text.slice(0, firstNewline).trim();
  const secondLine =
    text
      .slice(firstNewline + 1)
      .split("\n")[0]
      ?.trim() ?? "";

  const firstLineCommas = (firstLine.match(/,/g) || []).length;
  const secondLineCommas = (secondLine.match(/,/g) || []).length;

  if (firstLineCommas === 0 && secondLineCommas > 0) {
    return text.slice(firstNewline + 1);
  }

  return text;
}

export async function processCSV(file: File): Promise<CSVFile> {
  const text = stripTitleRow(await file.text());
  const blob = new Blob([text], { type: "text/csv" });
  const cleanFile = new File([blob], file.name, { type: "text/csv" });

  return new Promise((resolve, reject) => {
    parse(cleanFile, {
      header: true,
      skipEmptyLines: true,
      complete: (results: ParseResult<Record<string, string>>) => {
        resolve({ rows: results.data });
      },
      error: (error) => reject(error),
    });
  });
}
